export enum BOOK_INVITE_ASSIGNMENT_ACCENT {
    purple = 'purple',
    green = 'green',
    red = 'red',
    neutral = 'neutral',
}
